var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0m-12.75-.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m.947 2.722a.75.75 0 0 0-1.394.556c.26.651.812 1.143 1.445 1.464.642.326 1.424.508 2.252.508s1.61-.182 2.252-.508c.633-.321 1.185-.813 1.445-1.464a.75.75 0 0 0-1.394-.556c-.084.212-.31.47-.73.683-.412.208-.958.345-1.573.345-.616 0-1.162-.137-1.573-.345-.42-.213-.646-.471-.73-.683M16.5 10.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgSmile;